import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parseTimestamp(
  dateString: string | Date | null | undefined,
): number {
  return dateString ? new Date(dateString).getTime() : 0;
}
